import React, { useEffect } from "react"
import { useStore } from "react-reducer-store"
import PropTypes from "prop-types"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import differenceInMinutes from 'date-fns/differenceInMinutes'

const DialogBoxSession = props => {
  const { AppActions, AuthenticationUtil, graphBaseUrl } = props

  const appActions = AppActions()
  const {
    logout,
    getTokenRemainingTime,
    getAccessToken,
    refreshTokens,
  } = AuthenticationUtil
  const appStore = useStore(state => state.app)

  useEffect(() => {
    if (appStore && !appStore.showConfirmation) {
      hasActivity()
    }

    const authCheck = () => {
      const lastActivity = localStorage.getItem("OMNI_LAST_ACTIVITY")
      if (lastActivity) {
        const elapseMins = differenceInMinutes(
          new Date(),
          new Date(lastActivity)
        )
        console.log("elapseMins", elapseMins)
        if (elapseMins >= 12) {
          appActions.showConfirmation("Would you like to extend?")
        }

        if (elapseMins >= 15) {
          return logout()
        }
      } else {
        hasActivity()
      }

      return true

      /***** WRONG IMPLEM OF SESSION!!!!!
        const remainingTime = getTokenRemainingTime(getAccessToken())
        console.log( "remainingTime :::: ", remainingTime )

        // #remainingTimeCheck
        // show a modal box, option to refresh token (keep-alive)
        const minutesBeforeShowDialog = 2
        const seconds = 60 * minutesBeforeShowDialog
        if (remainingTime < seconds) {
          appActions.showConfirmation("Would you like to extend?")
        }

        // auto logout when remaining time < 1 second
        const oneSecond = 0.5 // value in seconds
        if (remainingTime < oneSecond) return logout()

        return true
       */
    }

    // check every {intervalMinutes} if the user has a valid token
    // if no valid token, redirect user to login screen
    //const milliSeconds = 300000//5 mins //1000 * 60 * intervalMinutes
    const milliSeconds = 900000 //15 mins //1000 * 60 * intervalMinutes
    const intervalAuthCheck = setInterval(authCheck, milliSeconds)
    // cleanup
    return () => clearInterval(intervalAuthCheck)

  }, [appActions, getAccessToken, getTokenRemainingTime, logout])

  const handleLogout = () => logout()

  // const handleRefreshToken = () =>
  //   refreshTokens(graphBaseUrl)
  //     .then(() => appActions.hideConfirmation())
  //     .catch(err => {
  //       console.error("handleRefreshToken", err)
  //     })

  const hasActivity = () => {
    localStorage.setItem("OMNI_LAST_ACTIVITY", new Date())
  }

  const handleRefreshToken = () => {
    appActions.hideConfirmation()
    hasActivity()
  }

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="xs"
      open={appStore ? appStore.showConfirmation : false}
      onClose={handleLogout}
    >
      <DialogTitle id="alert-dialog-title">
        Your session is about to expire.
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {appStore ? appStore.message : ""}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogout} color="secondary">
          No
        </Button>
        <Button onClick={handleRefreshToken} color="primary" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DialogBoxSession.propTypes = {
  graphBaseUrl: PropTypes.string.isRequired,
  AppActions: PropTypes.func.isRequired,
  AuthenticationUtil: PropTypes.shape({
    logout: PropTypes.func.isRequired,
    getTokenRemainingTime: PropTypes.func.isRequired,
    getAccessToken: PropTypes.func.isRequired,
    refreshTokens: PropTypes.func.isRequired,
  }).isRequired,
}

export default DialogBoxSession
